export default {
 TOOLTIP:'A <b>Warrant Agreement</b> sets out the terms and conditions of a warrant, such the rights of a holder to purchase shares, the type and number of shares and warrant coverage. '
}